var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.896 2.64258H15.896V0.642578H13.896V2.64258H5.896V0.642578H3.896V2.64258H2.896C1.786 2.64258 0.905996 3.54258 0.905996 4.64258L0.895996 18.6426C0.895996 19.173 1.10671 19.6817 1.48178 20.0568C1.85686 20.4319 2.36556 20.6426 2.896 20.6426H16.896C17.996 20.6426 18.896 19.7426 18.896 18.6426V4.64258C18.896 3.54258 17.996 2.64258 16.896 2.64258ZM16.896 18.6426H2.896V8.64258H16.896V18.6426ZM16.896 6.64258H2.896V4.64258H16.896V6.64258ZM6.896 12.6426H4.896V10.6426H6.896V12.6426ZM10.896 12.6426H8.896V10.6426H10.896V12.6426ZM14.896 12.6426H12.896V10.6426H14.896V12.6426ZM6.896 16.6426H4.896V14.6426H6.896V16.6426ZM10.896 16.6426H8.896V14.6426H10.896V16.6426ZM14.896 16.6426H12.896V14.6426H14.896V16.6426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalIcon);
export default __webpack_public_path__ + "static/media/cal-icon.a0b79d1d9434bb9ea7e52c08172296ae.svg";
export { ForwardRef as ReactComponent };